module.exports = __webpack_public_path__ + "img/about4.270ec8f5.png";